import styled from "styled-components";

export const Title = styled.div`
  font-family: Poppins;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 22px;
  letter-spacing: 0.01em;
  color: ${props => props.theme.colors[23]};
  margin: 0 0 10px;
`;
